import { css } from 'styled-components';

export const CommonButtonStyles = css`
  box-sizing: border-box;
  position: relative;
  display: inline-block;
  line-height: 1.5rem;
  max-width: 100%;

  ${(props) =>
    props.disabled &&
    ` opacity: 0.3;
      pointer-events: none;
    `}

  font-family: 'Untitled Sans', sans-serif;
  font-size: 1rem;
  text-align: left;
  cursor: pointer;
  user-select: none;
`;
